import React, { useState } from "react";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { toast } from "sonner";
import { Mail, Check } from "lucide-react";

export default function NewsletterForm({ variant = "default", source = "website", compact = false }) {
  // variant: "default" (light) | "dark"
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email, first_name: firstName, source });
      setDone(true);
      toast.success(data.already_subscribed ? "You're already a member of Between The Lines." : "Welcome to Between The Lines.");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Sign-up failed");
    } finally {
      setBusy(false);
    }
  };

  const isDark = variant === "dark";

  if (done) {
    return (
      <div className={`flex items-center gap-2 text-sm ${isDark ? "text-sidebar-fg" : "text-foreground"}`} data-testid="newsletter-success">
        <Check className="h-4 w-4 text-accent" strokeWidth={1.5} />
        <span className="italic">You&apos;re on the list. A welcome letter is on its way.</span>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className={compact ? "flex flex-col sm:flex-row gap-2" : "space-y-3"} data-testid="newsletter-form">
      <Input
        type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)}
        placeholder="First name"
        className={`rounded-sm ${isDark ? "bg-[hsl(270_25%_16%)] border-[hsl(270_20%_22%)] text-sidebar-fg placeholder:text-sidebar-muted" : "bg-background"} ${compact ? "sm:max-w-[160px]" : ""}`}
        data-testid="newsletter-first-name"
      />
      <Input
        type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
        placeholder="you@example.com"
        className={`rounded-sm ${isDark ? "bg-[hsl(270_25%_16%)] border-[hsl(270_20%_22%)] text-sidebar-fg placeholder:text-sidebar-muted" : "bg-background"} flex-1`}
        data-testid="newsletter-email"
      />
      <Button type="submit" disabled={busy} className="rounded-sm uppercase tracking-wide whitespace-nowrap" data-testid="newsletter-submit">
        <Mail className="h-3.5 w-3.5 mr-2" strokeWidth={1.5} /> {busy ? "Joining…" : "Join the club"}
      </Button>
    </form>
  );
}
